import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEye, FaEyeSlash, FaCheck, FaTimes } from 'react-icons/fa';

const LuxuryInput = ({
                         type = 'text',
                         label,
                         value,
                         onChange,
                         error,
                         success,
                         required = false,
                         disabled = false,
                         size = 'medium',
                         className = '',
                         ...props
                     }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const isFloating = isFocused || value?.length > 0;

    const sizeClasses = {
        small: 'px-3 py-2 text-sm rounded-lg',
        medium: 'px-4 py-3 text-base rounded-xl',
        large: 'px-5 py-4 text-lg rounded-xl'
    };

    return (
        <div className={`relative ${className}`}>
            {/* Label */}
            {label && (
                <motion.label
                    initial={false}
                    animate={{
                        y: isFloating ? -8 : 0,
                        scale: isFloating ? 0.85 : 1,
                        opacity: isFloating ? 1 : 0
                    }}
                    transition={{ duration: 0.2 }}
                    className="absolute left-4 px-1 z-10 pointer-events-none text-champagne bg-white -top-2"
                >
                    {label}
                    {required && <span className="text-error ml-1">*</span>}
                </motion.label>
            )}

            {/* Input */}
            <div className="relative">
                <input
                    type={type === 'password' && showPassword ? 'text' : type}
                    value={value}
                    onChange={onChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    disabled={disabled}
                    autoComplete="off"
                    placeholder={!isFloating ? props.placeholder : ''}
                    className={`
                        w-full
                        ${sizeClasses[size]}
                        bg-white
                        border
                        ${error ? 'border-error/50' : success ? 'border-sage/50' : 'border-nude'}
                        focus:outline-none
                        focus:border-champagne
                        focus:ring-1
                        focus:ring-champagne/30
                        text-charcoal
                        placeholder:text-charcoal/30
                        disabled:opacity-50
                        disabled:cursor-not-allowed
                        transition-all
                        duration-300
                        ${label ? 'pt-5 pb-2' : ''}
                    `}
                />

                {/* Password Toggle */}
                {type === 'password' && (
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-charcoal/30 hover:text-charcoal/50"
                    >
                        {showPassword ? <FaEyeSlash className="w-4 h-4" /> : <FaEye className="w-4 h-4" />}
                    </button>
                )}

                {/* Success / Error Icons */}
                {success && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-sage">
                        <FaCheck className="w-4 h-4" />
                    </div>
                )}

                {error && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-error">
                        <FaTimes className="w-4 h-4" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default LuxuryInput;
